module.exports = __webpack_public_path__ + "img/camera.be5030ca.webp";